import HorizontalLayout from "Container/HorizontalLayout";
import BangTongHopCongNoKhac from "../views/QuanLyTaiChinh/BangTongHopCongNoKhac.vue";

// dashboard components
const Dashboard = () => import("Views/dashboard/Dashboard");

// Phiếu Component
const PhieuCoc = () => import("Views/Phieu/PhieuCoc");
const PhieuBaoTraPhong = () => import("Views/Phieu/PhieuBaoTraPhong");
const PhieuThongTinNhanPhong = () =>
  import("Views/Phieu/PhieuThongTinNhanPhong");
const PhieuThayDoiThongTin = () =>
  import("Views/PhieuThayDoiThongTin/PhieuThayDoiThongTin");
const PhieuThuChi = () => import("Views/Phieu/PhieuThuChi");
const PhieuThuTienPhong = () => import("Views/Phieu/PhieuThuTienPhong");
const PhieuDieuChinh = () => import("Views/Phieu/PhieuDieuChinh");

// Phieu Thu Co Gam
const PhieuThuCoGamLayout = () =>
  import("../views/PhieuThuCoGam/PhieuThuCoGamLayout.vue");
const PhieuChi = () => import("../views/PhieuChi/PhieuChi.vue");

// Quản Lý Chứng Từ
const PhieuCocSaiFormat = () => import("Views/QuanLyChungTu/PhieuCocSaiFormat");
const PhieuCocLienTuc = () => import("Views/QuanLyChungTu/PhieuCocLienTuc");

// Quản Lý Khách Hàng
const TongQuanHopDong = () => import("Views/KhachHang/TongQuanHopDong");
const BangKhachHang = () => import("Views/KhachHang/BangKhachHang");
const TheXe = () => import("Views/KhachHang/TheXe");

// Quản Lý Phòng
const TheoDoiTinhTrangPhong = () =>
  import("Views/QuanLyPhong/TheoDoiTinhTrangPhong");
const BangTheoDoiCoc = () => import("Views/QuanLyPhong/BangTheoDoiCoc");
const ThongTinPhong = () => import("Views/QuanLyPhong/ThongTinPhong");
const BaoCaoNhanPhong = () => import("Views/QuanLyPhong/BaoCaoNhanPhong");
const BaoCaoTraPhong = () => import("Views/QuanLyPhong/BaoCaoTraPhong");
const BaoCaoTraCoc = () => import("Views/QuanLyPhong/BaoCaoTraCoc");
const BangThayDoiThongTin = () =>
  import("Views/QuanLyPhong/BangThayDoiThongTin");
const KiemSoatDienNuoc = () => import("Views/DienNuoc/KiemSoatDienNuoc");

// Quản Lý Tài Chính
const BangTinhTien = () => import("Views/QuanLyTaiChinh/BangTinhTien");
const DanhSachNoTienPhong = () =>
  import("Views/QuanLyTaiChinh/DanhSachNoTienPhong");
const BangTinhTienTraCoc = () =>
  import("Views/QuanLyTaiChinh/BangTinhTienTraCoc");
const BangTongHopPhieuThuTien = () =>
  import("Views/QuanLyTaiChinh/BangTongHopPhieuThuTien");
const BaoCaoTienPhongChuaThu = () =>
  import("Views/QuanLyTaiChinh/BaoCaoTienPhongChuaThu");
const SoTienNganHang = () => import("Views/QuanLyTaiChinh/SoTienNganHang/SoTienNganHang");
const SoTienMat = () => import("Views/QuanLyTaiChinh/SoTienMat");
const NhatKyChung = () => import("Views/QuanLyTaiChinh/NhatKyChung");
const BaoCaoTienCocChuaThu = () =>
  import("Views/QuanLyTaiChinh/BaoCaoTienCocChuaThu");
const BangTongHopCongNo = () =>
  import("Views/QuanLyTaiChinh/BangTongHopCongNo");

const TienDanPhong = () => import("Views/TienDanPhong/TienDanPhong");
// Điện nước
const BangDienNuoc = () => import("Views/DienNuoc/NhapDienNuoc");

// User
const Logs = () => import("Views/User/Logs");

//Internet
const Internet = () => import("Views/Internet/Internet");

//Admin
const Admin = () => import("Views/Admin/Admin");

export default {
  path: "/",
  component: HorizontalLayout,
  redirect: "/dashboard",
  children: [
    {
      component: Dashboard,
      path: "/dashboard",
      meta: {
        requiresAuth: true,
        title: "message.dashboard",
        breadcrumb: "Dashboard / Trang chủ",
      },
    },
    {
      component: PhieuCoc,
      path: "/bao-cao-nhan-coc",
      meta: {
        requiresAuth: true,
        title: "PHIẾU THU TIỀN ĐẶT CỌC",
        breadcrumb: "Dashboard / Phiếu thu tiền đặt cọc",
      },
    },
    {
      component: PhieuThongTinNhanPhong,
      path: "/phieu-thong-tin-nhan-phong",
      meta: {
        requiresAuth: true,
        title: "PHIẾU THÔNG TIN NHẬN PHÒNG",
        breadcrumb: "Dashboard / Phiếu thông tin nhận phòng",
      },
    },
    {
      component: PhieuThayDoiThongTin,
      path: "/phieu-thay-doi-thong-tin",
      meta: {
        requiresAuth: true,
        title: " PHIẾU THAY ĐỔI THÔNG TIN",
        breadcrumb: "Dashboard / Phiếu thay đổi thông tin",
      },
    },
    {
      component: PhieuBaoTraPhong,
      path: "/phieu-bao-tra-phong",
      meta: {
        requiresAuth: true,
        title: "PHIẾU BÁO TRẢ PHÒNG",
        breadcrumb: "Dashboard / Phiếu báo trả phòng",
      },
    },
    // {
    //    component: PhieuThuChi,
    //    path: '/phieu-thu-chi',
    //    meta: {
    //       requiresAuth: true,
    //       title: 'PHIẾU THU CÔ GẤM',
    //       breadcrumb: 'Dashboard / Phiếu thu cô Gấm'
    //    }
    // },
    {
      component: PhieuThuCoGamLayout,
      path: "/phieu-thu-chi",
      meta: {
        requiresAuth: true,
        title: "PHIẾU THU CÔ GẤM",
        breadcrumb: "Dashboard / Phiếu thu cô Gấm",
      },
    },
    {
      component: PhieuCocSaiFormat,
      path: "/phieu-coc-sai-format",
      meta: {
        requiresAuth: true,
        title: "Phiếu Cọc Sai Format",
        breadcrumb: "Dashboard / Phiếu cọc sai format",
      },
    },
    {
      component: PhieuCocLienTuc,
      path: "/phieu-coc-lien-tuc",
      meta: {
        requiresAuth: true,
        title: "Phiếu Cọc Liên Tục",
        breadcrumb: "Dashboard / Phiếu cọc liên tục",
      },
    },
    {
      component: TongQuanHopDong,
      path: "/hop-dong-thue-phong",
      meta: {
        requiresAuth: true,
        title: "HỢP ĐỒNG THUÊ PHÒNG",
        breadcrumb: "Dashboard / Hợp đồng thuê phòng",
      },
    },
    {
      component: BangKhachHang,
      path: "/bang-khach-hang",
      meta: {
        requiresAuth: true,
        title: "DANH SÁCH KHÁCH HÀNG",
        breadcrumb: "Dashboard / Danh sách khách hàng",
      },
    },
    {
      component: BaoCaoNhanPhong,
      path: "/bao-cao-nhan-phong",
      meta: {
        requiresAuth: true,
        title: "BÁO CÁO NHANH NHẬN PHÒNG",
        breadcrumb: "Dashboard / Báo cáo nhanh nhận phòng",
      },
    },
    {
      component: ThongTinPhong,
      path: "/thong-tin-phong",
      meta: {
        requiresAuth: true,
        title: "THÔNG TIN PHÒNG",
        breadcrumb: "Dashboard / Thông tin phòng",
      },
    },
    {
      component: BaoCaoTraPhong,
      path: "/bao-cao-tra-phong",
      meta: {
        requiresAuth: true,
        title: "message.baoCaoNhanhTraPhong",
        breadcrumb: "Dashboard / Báo cáo nhanh trả phòng",
      },
    },
    {
      component: BangThayDoiThongTin,
      path: "/so-theo-doi-thay-doi-thong-tin",
      meta: {
        requiresAuth: true,
        title: "message.soTheoDoiThayDoiThongTin",
        breadcrumb: "Dashboard / Sổ Theo Dõi Thay Đổi Thông Tin",
      },
    },
    {
      component: BangTinhTien,
      path: "/bang-tinh-tien",
      meta: {
        requiresAuth: true,
        title: "BẢNG TÍNH TIỀN",
        breadcrumb: "Dashboard / Bảng tính tiền",
      },
    },
    {
      component: TienDanPhong,
      path: "/tien-dan-phong",
      meta: {
        requiresAuth: true,
        title: "TIỀN DẪN PHÒNG",
        breadcrumb: "Dashboard / Tiền dẫn phòng",
      },
    },
    {
      component: DanhSachNoTienPhong,
      path: "/danh-sach-no-tien-phong",
      meta: {
        requiresAuth: true,
        title: "DANH SÁCH NỢ TIỀN PHÒNG",
        breadcrumb: "Dashboard / Danh sách nợ tiền phòng",
      },
    },
    {
      component: BangTinhTienTraCoc,
      path: "/bang-tinh-tien-tra-coc",
      meta: {
        requiresAuth: true,
        title: "BẢNG TÍNH TIỀN TRẢ CỌC",
        breadcrumb: "Dashboard / Bảng tính tiền trả cọc",
      },
    },
    {
      component: BangTongHopPhieuThuTien,
      path: "/bang-tong-hop-phieu-thu-tien",
      meta: {
        requiresAuth: true,
        title: "message.bangTongHopPhieuThuTien",
        breadcrumb: "Dashboard / Bảng Tổng Hợp Phiếu Thu Tiền",
      },
    },
    {
      component: BaoCaoTienPhongChuaThu,
      path: "/bao-cao-tien-phong-chua-thu",
      meta: {
        requiresAuth: true,
        title: "message.baoCaoTienPhongChuaThu",
        breadcrumb: "Dashboard / Báo Cáo Nợ Tiền Phòng Chưa Thu",
      },
    },
    {
      component: SoTienNganHang,
      path: "/so-tien-ngan-hang",
      meta: {
        requiresAuth: true,
        title: "message.soTienNganHang",
        breadcrumb: "Dashboard / Sổ Tiền Ngân Hàng",
      },
    },
    {
      component: SoTienMat,
      path: "/so-tien-mat",
      meta: {
        requiresAuth: true,
        title: "message.soTienMat",
        breadcrumb: "Dashboard / Sổ Tiền Mặt",
      },
    },
    {
      component: NhatKyChung,
      path: "/nhat-ky-chung",
      meta: {
        requiresAuth: true,
        title: "message.nhatKyChung",
        breadcrumb: "Dashboard / Nhật Ký Chung",
      },
    },
    {
      component: BangTongHopCongNo,
      path: "/bang-tong-hop-cong-no",
      meta: {
        requiresAuth: true,
        title: "BẢNG TỔNG HỢP CÔNG NỢ",
        breadcrumb: "Dashboard / Bảng tổng hợp công nợ",
      },
    },
    {
      component: BangTongHopCongNoKhac,
      path: "/bang-tong-hop-cong-no-khac",
      meta: {
        requiresAuth: true,
        title: "BẢNG TỔNG HỢP CÔNG NỢ KHÁC",
        breadcrumb: "Dashboard / Bảng tổng hợp công nợ khác",
      },
    },
    {
      component: BaoCaoTraCoc,
      path: "/bao-cao-tra-coc",
      meta: {
        requiresAuth: true,
        title: "message.baoCaoTraCoc",
        breadcrumb: "Dashboard / Báo Cáo Trả Cọc",
      },
    },
    {
      component: BaoCaoTienCocChuaThu,
      path: "/bao-cao-tien-coc-chua-thu",
      meta: {
        requiresAuth: true,
        title: "message.baoCaoTienCocChuaThu",
        breadcrumb: "Dashboard / Báo Cáo Nợ Tiền Cọc Chưa Thu",
      },
    },
    {
      component: BangDienNuoc,
      path: "/bang-so-dien",
      meta: {
        requiresAuth: true,
        title: "bảng số điện",
        breadcrumb: "Dashboard / Bảng Số Điện",
        type: "E",
      },
    },
    {
      component: BangDienNuoc,
      path: "/bang-so-nuoc",
      meta: {
        requiresAuth: true,
        title: "message.bangSoNuoc",
        breadcrumb: "Dashboard / Bảng Số Nước",
        type: "W",
      },
    },
    {
      component: BangTheoDoiCoc,
      path: "/theo-doi-coc",
      meta: {
        requiresAuth: true,
        title: "message.bangTheoDoiCoc",
        breadcrumb: "Dashboard / Bảng theo dõi cọc",
      },
    },
    {
      component: TheoDoiTinhTrangPhong,
      path: "/theo-doi-tinh-trang-phong",
      meta: {
        requiresAuth: true,
        title: "message.theoDoiTinhTrangCoc",
        breadcrumb: "Dashboard / Bảng heo dõi tình trạng phòng",
      },
    },
    {
      component: PhieuThuTienPhong,
      path: "/phieu-thu-tien-phong",
      meta: {
        requiresAuth: true,
        title: "PHIẾU THU TIỀN PHÒNG",
        breadcrumb: "Dashboard / Phiếu thu tiền phòng",
      },
    },
    {
      component: PhieuThuCoGamLayout,
      path: "/phieu-thu-co-gam",
      meta: {
        requiresAuth: true,
        title: "PHIẾU THU CÔ GẤM",
        breadcrumb: "Dashboard / Phiếu thu cô Gấm",
      },
    },
    {
      component: PhieuDieuChinh,
      path: "/phieu-dieu-chinh",
      meta: {
        requiresAuth: true,
        title: "PHIẾU ĐIỀU CHỈNH",
        breadcrumb: "Dashboard / Phiếu điều chỉnh",
      },
    },
    {
      component: Logs,
      path: "/logs",
      meta: {
        requiresAuth: true,
        title: "LỊCH SỬ HOẠT ĐỘNG",
        breadcrumb: "Dashboard / Lịch sử hoạt động",
      },
    },
    {
      component: Internet,
      path: "/internet",
      meta: {
        requiresAuth: true,
        title: "Internet",
        breadcrumb: "Dashboard / Internet",
      },
    },
    {
      component: Admin,
      path: "/admin",
      meta: {
        requiresAuth: true,
        requiresAdmin: true,
        title: "Admin",
        breadcrumb: "Dashboard / Admin",
      },
    },
    {
      component: PhieuChi,
      path: "/phieu-chi",
      meta: {
        requiresAuth: true,
        title: "Phiếu Chi",
        breadcrumb: "Dashboard / Phiếu Chi",
      },
    },
    {
      component: TheXe,
      path: "/the-xe",
      meta: {
        requiresAuth: true,
        title: "Thẻ Xe",
        breadcrumb: "Dashboard / Thẻ Xe",
      },
    },
    {
      component: KiemSoatDienNuoc,
      path: "/kiem-soat-dien-nuoc",
      meta: {
        requiresAuth: true,
        title: "Kiểm Soát Điện Nước",
        breadcrumb: "Dashboard / Kiểm Soát Điện Nước",
      },
    },
  ],
};
